var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";
import styled from "styled-components";
import DynamicFactory, { Button, Label, LinearLayout, View, getStructureValues, updateStructureValues } from "../DynamicFactory";
import defaultStructure from "./structure";
import mock from "./mock";
import { formatAddress, formatAllHours, getAllHours, getTodaysHours } from "./utils";
import merge from "../helpers/merge";
export var defaultConfig = {
  showAddress: true,
  showPhoneNumber: true,
  showWaitTime: true,
  showStoreHours: true,
  showPickUpHours: true,
  showDeliveryHours: true
};
export var defaultStyles = {
  primaryButtonBackgroundColor: "#feed01",
  primaryButtonTextColor: "#3d3d3d",
  secondaryButtonBackgroundColor: "#ffffff",
  secondaryButtonTextColor: "#666666",
  buttonStyle: "rounded"
}; // Source dictionary for component style

var dictionary = {
  primaryButtonBackgroundColor: "buttons.LocationCard_OrderNowButton.fillColor",
  primaryButtonTextColor: "labels.LocationCard_OrderNowButtonLabel_unselected.fillColor",
  secondaryButtonBackgroundColor: "buttons.LocationCard_ScheduleForLaterButton.fillColor",
  secondaryButtonTextColor: "labels.LocationCard_ScheduleForLaterButtonLabel_unselected.fillColor"
}; // Target dictionary for component style

var updateDictionary = {
  primaryButtonBackgroundColor: ["buttons.LocationCard_OrderNowButton.fillColor", "buttons.LocationCard_PreorderButton.fillColor"],
  primaryButtonTextColor: ["buttons.LocationCard_OrderNowButton.label.fillColor", "buttons.LocationCard_PreorderButton.label.fillColor"],
  secondaryButtonBackgroundColor: ["buttons.LocationCard_ScheduleForLaterButton.fillColor"],
  secondaryButtonTextColor: ["buttons.LocationCard_ScheduleForLaterButton.label.fillColor"]
};
var MarketplaceIcon = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 3rem;\n  max-height: 3rem;\n  border-radius: 100%;\n  border: 1px solid #e0e0e0;\n  margin-right: 0.75rem;\n"], ["\n  max-width: 3rem;\n  max-height: 3rem;\n  border-radius: 100%;\n  border: 1px solid #e0e0e0;\n  margin-right: 0.75rem;\n"])));

var populatedStates = function populatedStates(structure, sx) {
  if (sx === void 0) {
    sx = {};
  }

  var construct = merge(defaultStructure, structure);

  var newStyle = __assign(__assign(__assign({}, defaultStyles), getStructureValues(dictionary, construct)), sx); // TODO: Remove update structure values, use Button sx prop instead


  var newStructure = updateStructureValues(updateDictionary, construct, sx);
  return {
    sx: newStyle,
    structure: newStructure
  };
};
/**
 * Renders a single location card.
 *
 * Behaviors:
 * - Daily and store hours can be toggled if they're not
 *   the same for each day.
 * - The "button" (actually a link) for the card has text
 *   that depends on whether the store is open or not.
 * - If a store is closed, the button isn't clickable.
 * - The card receives a `data-locationid` element so it
 *   can be targetted by map events for scrolling without
 *   having to manage a bunch of messy refs.
 */


function LocationCard(_a) {
  var _b, _c;

  var _d = _a.config,
      config = _d === void 0 ? {} : _d,
      _e = _a.location,
      location = _e === void 0 ? mock.location : _e,
      // onClick,
  onOrderClick = _a.onOrderClick,
      onPreorderClick = _a.onPreorderClick,
      onScheduleClick = _a.onScheduleClick,
      onMarketplaceClick = _a.onMarketplaceClick,
      onUpdate = _a.onUpdate,
      _f = _a.orderType,
      orderType = _f === void 0 ? "pickup" : _f,
      _g = _a.structure,
      structure = _g === void 0 ? {} : _g,
      _h = _a.sx,
      sx = _h === void 0 ? defaultStyles : _h;
  var primaryButtonBackgroundColor = sx.primaryButtonBackgroundColor,
      primaryButtonTextColor = sx.primaryButtonTextColor,
      secondaryButtonBackgroundColor = sx.secondaryButtonBackgroundColor,
      secondaryButtonTextColor = sx.secondaryButtonTextColor,
      buttonStyle = sx.buttonStyle;

  var _j = React.useMemo(function () {
    return populatedStates(structure, __assign(__assign(__assign(__assign(__assign({}, primaryButtonBackgroundColor !== "#feed01" && {
      primaryButtonBackgroundColor: primaryButtonBackgroundColor
    }), primaryButtonTextColor !== "#3d3d3d" && {
      primaryButtonTextColor: primaryButtonTextColor
    }), secondaryButtonBackgroundColor !== "#ffffff" && {
      secondaryButtonBackgroundColor: secondaryButtonBackgroundColor
    }), secondaryButtonTextColor !== "#666666" && {
      secondaryButtonTextColor: secondaryButtonTextColor
    }), {
      buttonStyle: buttonStyle
    }));
  }, [sx, structure]),
      style = _j.sx,
      dynamicStructure = _j.structure;

  var _k = React.useState(false),
      toogleStoreButton = _k[0],
      setToggleStoreButton = _k[1];

  var _l = React.useState(false),
      tooglePickupButton = _l[0],
      setTogglePickupButton = _l[1];

  var _m = React.useState(false),
      toogleDeliveryButton = _m[0],
      setToggleDeliveryButton = _m[1];

  var hours = (location === null || location === void 0 ? void 0 : location.hours) || []; // const allDailyHours = getAllHours(hours, orderType);

  var allStoreHours = getAllHours(hours, "kiosk");
  var allPickupHours = getAllHours(hours, "pickup");
  var allDeliveryHours = getAllHours(hours, "delivery");
  var canStoreHoursBeExpanded = allStoreHours.length > 1;
  var canPickupHoursBeExpanded = allPickupHours.length > 1;
  var canDeliveryHoursBeExpanded = allDeliveryHours.length > 1;

  var _o = __assign(__assign({}, defaultConfig), config),
      showAddress = _o.showAddress,
      showPhoneNumber = _o.showPhoneNumber,
      showWaitTime = _o.showWaitTime,
      showStoreHours = _o.showStoreHours,
      showPickUpHours = _o.showPickUpHours,
      showDeliveryHours = _o.showDeliveryHours;

  var isDistanceNumber = (location === null || location === void 0 ? void 0 : location.distanceInMiles) && typeof (location === null || location === void 0 ? void 0 : location.distanceInMiles) === "number";
  React.useEffect(function () {
    if (onUpdate) {
      onUpdate({
        structure: dynamicStructure,
        sx: style,
        config: __assign(__assign({}, defaultConfig), config)
      });
    }
  }, []);
  return React.createElement(DynamicFactory, {
    structure: dynamicStructure,
    entry: "LocationCard",
    dynamicValues: {
      LocationCard_LocationLabel: [(location === null || location === void 0 ? void 0 : location.name) || ""],
      LocationCard_AddressLabel: [formatAddress(location === null || location === void 0 ? void 0 : location.address)],
      LocationCard_DistanceLabel: [isDistanceNumber && ((_b = location === null || location === void 0 ? void 0 : location.distanceInMiles) === null || _b === void 0 ? void 0 : _b.toFixed(1)) || ""],
      LocationCard_TimeLabel: [(location === null || location === void 0 ? void 0 : location.estimatedTime) || ""],
      LocationCard_PhoneLabel: [(location === null || location === void 0 ? void 0 : location.phoneNumber) || ""],
      LocationCard_StoreOpenNowLabel: [toogleStoreButton ? "" : ": ".concat(getTodaysHours(hours, "kiosk", false))],
      LocationCard_PickupOpenNowLabel: [tooglePickupButton ? "" : ": ".concat(getTodaysHours(hours, "pickup", false))],
      LocationCard_DeliveryOpenNowLabel: [toogleDeliveryButton ? "" : ": ".concat(getTodaysHours(hours, "delivery", false))],
      LocationCard_SeeAllRestaurantsLabel: ["".concat(((_c = location === null || location === void 0 ? void 0 : location.restaurantGroups) === null || _c === void 0 ? void 0 : _c.length) || "0")]
    },
    renderers: {
      LocationCard: function LocationCard(p) {
        return React.createElement(View, __assign({
          "data-locationid": location === null || location === void 0 ? void 0 : location.id
        }, p));
      },
      LocationCard_DistanceWrapperLayout: function LocationCard_DistanceWrapperLayout(p) {
        return (isDistanceNumber || showWaitTime && (location === null || location === void 0 ? void 0 : location.estimatedTime)) && React.createElement(LinearLayout, __assign({}, p));
      },
      LocationCard_PhoneAddressWrapper: function LocationCard_PhoneAddressWrapper(p) {
        return (showAddress || showPhoneNumber) && React.createElement(View, __assign({}, p));
      },
      LocationCard_AddressWrapper: function LocationCard_AddressWrapper(p) {
        return showAddress && React.createElement(View, __assign({}, p));
      },
      LocationCard_PhoneWrapper: function LocationCard_PhoneWrapper(p) {
        return showPhoneNumber && (location === null || location === void 0 ? void 0 : location.phoneNumber) && React.createElement(View, __assign({}, p));
      },
      // Labels
      LocationCard_LocationLabel: function LocationCard_LocationLabel(p) {
        return React.createElement(Label, __assign({}, p, {
          as: "h2"
        }));
      },
      LocationCard_TimeLabel: function LocationCard_TimeLabel(p) {
        return showWaitTime && (location === null || location === void 0 ? void 0 : location.estimatedTime) && React.createElement(Label, __assign({}, p));
      },
      LocationCard_DistanceLabel: function LocationCard_DistanceLabel(p) {
        return isDistanceNumber && React.createElement(Label, __assign({}, p));
      },
      LocationCard_SeparatorLabel: function LocationCard_SeparatorLabel(p) {
        return isDistanceNumber && React.createElement(Label, __assign({}, p));
      },
      // Icons
      LocationCard_AddressIcon: function LocationCard_AddressIcon(p) {
        return React.createElement(View, __assign({
          role: "img",
          "aria-label": "Address"
        }, p));
      },
      LocationCard_PhoneIcon: function LocationCard_PhoneIcon(p) {
        return React.createElement(View, __assign({
          role: "img",
          "aria-label": "Phone Number"
        }, p));
      },
      // Action buttons
      LocationCard_OrderNowButton: function LocationCard_OrderNowButton(p) {
        return typeof onOrderClick === "function" && React.createElement(Button, __assign({}, p, {
          sx: {
            buttonStyle: style.buttonStyle
          },
          onClick: onOrderClick,
          disabled: !(location === null || location === void 0 ? void 0 : location.isOpen)
        }));
      },
      LocationCard_PreorderButton: function LocationCard_PreorderButton(p) {
        return typeof onPreorderClick === "function" && React.createElement(Button, __assign({}, p, {
          sx: {
            buttonStyle: style.buttonStyle
          },
          onClick: onPreorderClick
        }));
      },
      LocationCard_ScheduleForLaterButton: function LocationCard_ScheduleForLaterButton(p) {
        return typeof onScheduleClick === "function" && React.createElement(Button, __assign({}, p, {
          sx: {
            buttonStyle: style.buttonStyle
          },
          onClick: onScheduleClick
        }));
      },
      // Store Hours
      LocationCard_StoreHours: function LocationCard_StoreHours(p) {
        return showStoreHours && React.createElement(View, __assign({}, p));
      },
      LocationCard_StoreHoursLabel: function LocationCard_StoreHoursLabel(p) {
        return React.createElement(Label, __assign({}, p, {
          as: "h3"
        }));
      },
      LocationCard_StoreHoursHeaderWrapper: function LocationCard_StoreHoursHeaderWrapper(p) {
        return React.createElement(View, __assign({}, p, canStoreHoursBeExpanded));
      },
      LocationCard_StoreHoursChevronButton: function LocationCard_StoreHoursChevronButton(p) {
        return canStoreHoursBeExpanded && React.createElement(Button, __assign({}, p, {
          selected: toogleStoreButton,
          "aria-expanded": toogleStoreButton,
          ariaLabel: "Store Hours",
          onClick: function onClick() {
            return setToggleStoreButton(function (prev) {
              return !prev;
            });
          },
          onKeyDown: function onKeyDown(e) {
            if (e.key === " " || e.key === "Enter") {
              setToggleStoreButton(function (prev) {
                return !prev;
              });
            }
          }
        }));
      },
      LocationCard_StoreHoursCollectionView: function LocationCard_StoreHoursCollectionView() {
        return toogleStoreButton && React.createElement(Label, {
          name: "LocationCard_DayLabel"
        }, formatAllHours(allStoreHours));
      },
      // Pickup Hours
      LocationCard_PickupHours: function LocationCard_PickupHours(p) {
        return showPickUpHours && orderType === "pickup" && React.createElement(View, __assign({}, p));
      },
      LocationCard_PickupHoursLabel: function LocationCard_PickupHoursLabel(p) {
        return React.createElement(Label, __assign({}, p, {
          as: "h3"
        }));
      },
      LocationCard_PickupHoursHeaderWrapper: function LocationCard_PickupHoursHeaderWrapper(p) {
        return React.createElement(View, __assign({}, p, canPickupHoursBeExpanded));
      },
      LocationCard_PickupHoursChevronButton: function LocationCard_PickupHoursChevronButton(p) {
        return canPickupHoursBeExpanded && React.createElement(Button, __assign({}, p, {
          selected: tooglePickupButton,
          "aria-expanded": tooglePickupButton,
          ariaLabel: "Pickup Hours",
          onClick: function onClick() {
            return setTogglePickupButton(function (prev) {
              return !prev;
            });
          },
          onKeyDown: function onKeyDown(e) {
            if (e.key === " " || e.key === "Enter") {
              setTogglePickupButton(function (prev) {
                return !prev;
              });
            }
          }
        }));
      },
      LocationCard_PickupHoursCollectionView: function LocationCard_PickupHoursCollectionView() {
        return tooglePickupButton && React.createElement(Label, {
          name: "LocationCard_DayLabel"
        }, formatAllHours(allPickupHours));
      },
      // Delivery Hours
      LocationCard_DeliveryHours: function LocationCard_DeliveryHours(p) {
        return showDeliveryHours && orderType === "delivery" && React.createElement(View, __assign({}, p));
      },
      LocationCard_DeliveryHoursLabel: function LocationCard_DeliveryHoursLabel(p) {
        return React.createElement(Label, __assign({}, p, {
          as: "h3"
        }));
      },
      LocationCard_DeliveryHoursHeaderWrapper: function LocationCard_DeliveryHoursHeaderWrapper(p) {
        return React.createElement(View, __assign({}, p, canDeliveryHoursBeExpanded));
      },
      LocationCard_DeliveryHoursChevronButton: function LocationCard_DeliveryHoursChevronButton(p) {
        return canDeliveryHoursBeExpanded && React.createElement(Button, __assign({}, p, {
          selected: toogleDeliveryButton,
          "aria-expanded": toogleDeliveryButton,
          ariaLabel: "Delivery Hours",
          onClick: function onClick() {
            return setToggleDeliveryButton(function (prev) {
              return !prev;
            });
          },
          onKeyDown: function onKeyDown(e) {
            if (e.key === " " || e.key === "Enter") {
              setToggleDeliveryButton(function (prev) {
                return !prev;
              });
            }
          }
        }));
      },
      LocationCard_DeliveryHoursCollectionView: function LocationCard_DeliveryHoursCollectionView() {
        return toogleDeliveryButton && React.createElement(Label, {
          name: "LocationCard_DayLabel"
        }, formatAllHours(allDeliveryHours));
      },
      // Marketplace - hiding until we have more design and tests
      LocationCard_SeeAllRestaurantsWrapper: function LocationCard_SeeAllRestaurantsWrapper(p) {
        var _a, _b;

        return (location === null || location === void 0 ? void 0 : location.restaurantGroups) && Boolean((_a = location === null || location === void 0 ? void 0 : location.restaurantGroups) === null || _a === void 0 ? void 0 : _a.length) && ((_b = location === null || location === void 0 ? void 0 : location.restaurantGroups) === null || _b === void 0 ? void 0 : _b.length) > 7 && React.createElement(View, __assign({}, p, {
          onClick: onMarketplaceClick
        }));
      },
      LocationCard_MarketplaceIconsWrapper: function LocationCard_MarketplaceIconsWrapper(p) {
        var _a, _b;

        return (location === null || location === void 0 ? void 0 : location.restaurantGroups) && Boolean((_a = location === null || location === void 0 ? void 0 : location.restaurantGroups) === null || _a === void 0 ? void 0 : _a.length) && ((_b = location === null || location === void 0 ? void 0 : location.restaurantGroups) === null || _b === void 0 ? void 0 : _b.length) <= 7 && React.createElement(View, __assign({}, p));
      },
      LocationCard_MarketplaceIconsCollectionView: function LocationCard_MarketplaceIconsCollectionView() {
        var _a;

        return React.createElement("div", {
          style: {
            display: "flex"
          }
        }, (_a = location === null || location === void 0 ? void 0 : location.restaurantGroups) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
          var id = _a.id,
              media = _a.media,
              name = _a.name;
          return React.createElement(MarketplaceIcon, {
            key: id,
            src: media === null || media === void 0 ? void 0 : media.restaurantIcon,
            alt: name
          });
        }));
      }
    }
  });
}

LocationCard.defaultProps = {
  config: defaultConfig,
  location: mock.location,
  onClick: undefined,
  onOrderClick: undefined,
  onPreorderClick: undefined,
  onScheduleClick: undefined,
  onUpdate: undefined,
  orderType: "pickup",
  structure: defaultStructure,
  sx: defaultStyles
};
export default LocationCard;
export { default as mock } from "./mock";
export { default as defaultStructure } from "./structure";
export * from "./types";
export * from "./utils";
var templateObject_1;